import React from 'react';
import { ImageAtoms, Svg } from '@vfit/shared/atoms';
import { Colors, purify } from '@vfit/shared/themes';
import { LogoContainer, MainContainer } from './topShoppingCartBanner.style';
import { useDeviceType } from '@vfit/shared/hooks';

export interface ITopShoppingCartBanner {
  isEnabledForAllPages?: string;
  isEnabled?: string;
  useHeaderConfig?: string;
  textColor?: string; // #5678
  background?: string;
  logo?: string;
  afterLogoLabel?: string;
  actionUrl?: string;
  isShown: boolean;
  setIsShown: (show: boolean) => void;
}

const TopShoppingCartBanner: React.FC<ITopShoppingCartBanner> = ({
  textColor,
  logo,
  background,
  afterLogoLabel,
  actionUrl,
  isShown,
  setIsShown,
}) => {
  const TOP_HEIGHT = 124;

  const [pAfterLogoLabel] = purify([afterLogoLabel || '']);
  const { isMobile } = useDeviceType();

  if (!isShown) return;

  return (
    <MainContainer
      color={textColor}
      style={{
        ...(background && { background }),
        ...(actionUrl && { cursor: 'pointer' }),
        height: isMobile ? `${TOP_HEIGHT}px` : '64px',
        transition: 'height 0.3s ease',
      }}
    >
      <div
        style={{ display: 'flex', transition: 'opacity 0.3s ease' }}
        className="logo-text-container"
      >
        {logo && (
          <LogoContainer>
            <ImageAtoms nameCard="topBannerLogo" image={logo} />
          </LogoContainer>
        )}
        {pAfterLogoLabel && <span dangerouslySetInnerHTML={{ __html: pAfterLogoLabel }} />}
      </div>

      <div className="top-banner-close">
        <div
          style={{
            cursor: 'pointer',
          }}
          onClick={() => setIsShown(false)}
        >
          <Svg name="close" width={21} color={textColor as Colors} />
        </div>
      </div>
    </MainContainer>
  );
};
export default TopShoppingCartBanner;

